import ActionTypes from '../constants/action-types';
import standardAction from '../../../utilities/standard-action';
import { RootActionTypes } from '../../../stores/types';

export default function showRefundFormDialog(): RootActionTypes {
  return standardAction(ActionTypes.SHOW_REFUND_FORM_DIALOG);
}
